import { z } from "zod";
import { addClientFormSchema } from "./fixtures";

export const PendingStatuses = ["pending", "Pending Qualification", "Application in Progress", "Pending Approval"];

export const ArchivedStatuses = ["removed", "left", "Permanently Terminated", "Retired", "Declined"];

export const SuspendedStatuses = ["suspended", "Temporarily Suspended"];

export const ActiveStatuses = ["active", "Approved"];

export type ClientsTableData = {
  name: JSX.Element;
  emailMobile: JSX.Element;
  company: JSX.Element;
  accountType: string;
  hearAboutUs: string;
  joined: string;
  status: JSX.Element;
  action: JSX.Element;
};

export type AddClientFormData = z.infer<typeof addClientFormSchema>;
